export default __webpack_public_path__ + "static/media/bureau-veritas-certification@2x.64978b88.png";